import Close from '../../icons/Close'
import Menu from '../../icons/Menu'
import Search from '../../icons/Search'
import Notification from '../../icons/Notification'
import Translate from '../../icons/Translate'
import React from 'react'

const Header = ({
  logoutUser,
  toggleSidebar,
  isSidebarOpen,
  toggleProfile,
  isProfileOpen,
  avatarUrl,
}) => {
  return (
    <header className="flex items-center justify-between px-6 bg-white h-20 shadow-md z-10">
      {/* Sidebar toggle button - always visible */}
      <div className="flex gap-4 justify-start items-center">
        <button
          onClick={toggleSidebar}
          className="text-gray-700 hover:text-gray-900 md:hidden"
        >
          {isSidebarOpen ? <Close color="black" /> : <Menu color="black" />}
        </button>
        <button
          onClick={toggleSidebar}
          className="text-gray-700 hover:text-gray-900 hidden md:block"
        >
          <Menu color="black" />
        </button>
        <button>
          <Search color="black" />
        </button>
      </div>

      <div className="flex items-center gap-4">
        <button>
          <Notification color="black" size="6" />
        </button>

        <button>
          <Translate color="black" size="6" />
        </button>

        <div
          className="relative inline-block text-left avatar-menu"
          onClick={toggleProfile}
        >
          {/* Avatar */}
          <img
            src={
              avatarUrl
                ? avatarUrl.replace('.glb', '.png')
                : '/images/avatar_default.png'
            }
            alt="Profile"
            className="w-8 h-8 rounded-full object-top object-cover bg-[#B0CBBE] cursor-pointer"
          />

          {/* Dropdown menu */}
          {isProfileOpen && (
            <div className="absolute right-0 mt-2 w-fit bg-white border border-gray-200 rounded-md shadow-lg z-10">
              <div className="py-1">
                <button
                  onClick={logoutUser}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-nowrap"
                >
                  Log out
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}

export default Header
